!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, s = {}, o = e.parcelRequire5f74;
  null == o && ((o = function(e) {
    if (e in t) return t[e].exports;
    if (e in s) {
      var o = s[e];
      delete s[e];
      var r = {
        id: e,
        exports: {}
      };
      return t[e] = r, o.call(r.exports, r, r.exports), r.exports;
    }
    var n = new Error("Cannot find module '" + e + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
  }).register = function(e, t) {
    s[e] = t;
  }, e.parcelRequire5f74 = o), (0, o.register)("gjV2B", function(e, t) {
    var s, o, r, n;
    s = e.exports, o = "debounce", r = function() {
      return i;
    }, Object.defineProperty(s, o, {
      get: r,
      set: n,
      enumerable: !0,
      configurable: !0
    });
    const i = (e, t) => {
      let s;
      const o = (...o) => {
        clearTimeout(s), s = setTimeout(() => {
          clearTimeout(s), e(...o);
        }, t);
      };
      return o.cancel = () => {
        clearTimeout(s), s = null;
      }, o;
    };
  }), o("gjV2B");
  customElements.get("custom-cursor") || customElements.define("custom-cursor", class extends HTMLElement {
    cursor=this.querySelector("div");
    target=this.dataset.target;
    hoverMQ=window.matchMedia("(hover: none)");
    constructor() {
      super(), this.onMouseEnter = e => this.on(e.target, e), this.onMouseMove = e => this.on(e.target, e), 
      this.onMouseLeave = e => this.off(e.target);
    }
    on(e, t) {
      const s = e.closest("video-player");
      !s || s?.querySelector("video")?.paused ? (e.classList.add("!cursor-none"), this.cursor.style.left = `${t.clientX}px`, 
      this.cursor.style.top = `${t.clientY}px`, this.cursor.classList.remove("scale-0")) : e.classList.remove("!cursor-none");
    }
    off(e) {
      this.cursor.classList.add("scale-0"), e.classList.remove("!cursor-none");
    }
    bind() {
      (this.closest(".shopify-section") || document.body).querySelectorAll(this.target).forEach(e => {
        e.addEventListener("mouseenter", this.onMouseEnter), e.addEventListener("mousemove", this.onMouseMove, {
          passive: !0
        }), e.addEventListener("mouseleave", this.onMouseLeave);
      });
    }
    addEventListeners() {
      this.cursor && this.target && this.bind();
    }
    removeEventListeners() {
      (this.closest(".shopify-section") || document.body).querySelectorAll(this.target).forEach(e => {
        e.removeEventListener("mouseenter", this.onMouseEnter), e.removeEventListener("mousemove", this.onMouseMove, {
          passive: !0
        }), e.removeEventListener("mouseleave", this.onMouseLeave), e.classList.remove("!cursor-none");
      }), this.cursor && this.cursor.classList.add("scale-0");
    }
    connectedCallback() {
      this.handleHoverChange = e => e.matches ? this.removeEventListeners() : this.addEventListeners(), 
      this.hoverMQ.matches || this.addEventListeners(), this.hoverMQ.addEventListener("change", this.handleHoverChange);
    }
    disconnectedCallback() {
      this.removeEventListeners(), this.hoverMQ.removeEventListener("change", this.handleHoverChange);
    }
  });
}();